// pages/AIConfigPage.js — Halaman khusus pengelolaan AI config GLOBAL.
// Akses: permission 'ai_settings' (didelegasikan admin lewat Role Management).
// Hanya mengatur config bersama (provider/model/api_key/parameter) — TIDAK
// menyentuh system prompt per-dashboard (itu tetap per-user via panel AI).
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadConfigFromServer, getDefaultConfig } from '../components/AI/aiConfig';
import AISettings from '../components/AI/AISettings';
import AILlmKeys from '../components/AI/AILlmKeys';
import AIRouterSettings from '../components/AI/AIRouterSettings';
import AIMemory from '../components/AI/AIMemory';
import AIAgentModels from '../components/AI/AIAgentModels';
import { useLang } from '../context/LanguageContext';

export default function AIConfigPage() {
  const navigate = useNavigate();
  const { t }    = useLang();
  const [config, setConfig]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab]         = useState('config'); // 'config' | 'keys'

  useEffect(() => {
    loadConfigFromServer()
      .then(cfg => setConfig(cfg || getDefaultConfig()))
      .catch(() => setConfig(getDefaultConfig()))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh-4rem)] gap-2 text-slate-400">
        <div className="w-4 h-4 border-2 border-brand-400 border-t-transparent rounded-full animate-spin" />
        <span className="text-xs">{t('aiw.loadingConfig')}</span>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto h-[calc(100vh-4rem)] flex flex-col">
      {/* Tab switcher */}
      <div className="flex items-center gap-1 px-1 pt-3 border-b border-slate-200">
        <button onClick={() => setTab('config')}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            tab === 'config' ? 'border-brand-600 text-brand-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
          Config
        </button>
        <button onClick={() => setTab('keys')}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            tab === 'keys' ? 'border-brand-600 text-brand-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
          LLM Keys
        </button>
        <button onClick={() => setTab('router')}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            tab === 'router' ? 'border-brand-600 text-brand-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
          Router
        </button>
        <button onClick={() => setTab('memory')}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            tab === 'memory' ? 'border-brand-600 text-brand-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
          Memory
        </button>
        <button onClick={() => setTab('agent')}
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            tab === 'agent' ? 'border-brand-600 text-brand-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`}>
          Agent SDK
        </button>
      </div>

      <div className="flex-1 overflow-auto pt-4">
        {tab === 'config' ? (
          // dashboardKey sengaja TIDAK diberikan → AISettings hanya mengatur config
          // global bersama (tanpa bagian system prompt per-dashboard).
          <AISettings
            config={config}
            onSave={setConfig}
            onClose={() => navigate('/dashboard')}
          />
        ) : tab === 'keys' ? (
          <AILlmKeys />
        ) : tab === 'memory' ? (
          <AIMemory />
        ) : tab === 'agent' ? (
          <AIAgentModels />
        ) : (
          <AIRouterSettings />
        )}
      </div>
    </div>
  );
}
